module.exports = __webpack_public_path__ + "img/b1.4d544bee.png";